import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { CodeTypeDataComponent } from '../code-type-data/code-type-data.component';
import { PageEvent } from '@angular/material/paginator';
import { TehasilDialogboxComponent } from '../tehasil-dialogbox/tehasil-dialogbox.component';

@Component({
  selector: 'app-tehasil',
  templateUrl: './tehasil.component.html',
  styleUrls: ['./tehasil.component.scss']
})
export class TehasilComponent implements OnInit {
  TehasilSearchForm: FormGroup;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  tehasilList: any;
  SessionNo: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
     private dialog: MatDialog,
    private modalPopupService: ModalpopService,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // private dialogRef2: MatDialogRef<TehasilDialogboxComponent>,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.TehasilSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.getTehasilData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  getTehasilData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    // payload['SearchString'] = this.TehasilSearchForm.value['SearchString'];
    this.umsService.getTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getTehasilData();
    // this.keypress();
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      let payload = {}
    payload['SearchString'] = this.TehasilSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchTehasil(payload).subscribe(res => {
      if(res.status){
        this.tehasilList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.tehasilList = [];
      this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.tehasilList = [];
    });
    },1000)
  
  }


  addnewrecord() {
    const dialogRef = this.dialog.open(TehasilDialogboxComponent, {
      width: '90vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getTehasilData();
      this.TehasilSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(TehasilDialogboxComponent, {
      width: '80vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getTehasilData();
      this.TehasilSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(TehasilDialogboxComponent, {
      width: '80vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getTehasilData();
      this.TehasilSearchForm.controls['SearchString'].setValue('');
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }


  Print(){
    let submitpayload = this.TehasilSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-Tehsil';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 116,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

}
